var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "main" },
      [
        _vm._l(2, function (items) {
          return _c("div", { key: items, staticClass: "mainBox" }, [
            _c(
              "div",
              { staticClass: "divLine" },
              [
                _c("svg-icon", {
                  staticStyle: { "margin-right": "0.05rem", height: "0.2rem" },
                  attrs: { iconClass: "naozhong" },
                }),
                _vm._m(0, true),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "divLine" },
              [
                _c("svg-icon", {
                  staticStyle: { "margin-right": "0.05rem", height: "0.2rem" },
                  attrs: { iconClass: "person" },
                }),
                _c("p", { staticClass: "p_1" }, [
                  _vm._v("人数:相对准确30人 (另一种情况是: 大致人数:30-50)"),
                ]),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass: "divLine",
                    staticStyle: { "margin-bottom": "0.2rem" },
                  },
                  [
                    _c("el-checkbox", {
                      model: {
                        value: _vm.checked,
                        callback: function ($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked",
                      },
                    }),
                    _c("p", { staticClass: "p_1" }, [_vm._v("类型:年会")]),
                  ],
                  1
                ),
                _vm._l(2, function (item) {
                  return _c("div", { key: item, staticClass: "detail" }, [
                    _c("p", { staticClass: "p_3" }, [
                      _vm._v("需要:福临门会议室期望3000￥以内"),
                    ]),
                    _vm._m(1, true),
                    _c("p", { staticClass: "p_3" }, [
                      _vm._v("想比较 龙腾会议室 的价格"),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ])
        }),
        _c(
          "div",
          { staticClass: "divLine" },
          [
            _c("svg-icon", {
              staticStyle: { "margin-right": "0.05rem", height: "0.2rem" },
              attrs: { iconClass: "md-spa" },
            }),
            _c("p", { staticClass: "p_1" }, [_vm._v("需要的设备及服务:")]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "serviceBox" },
          _vm._l(_vm.siteService, function (item, keys) {
            return _c(
              "div",
              { key: keys, staticClass: "serviceLine" },
              [
                _c("p", { staticClass: "serviceTitle" }, [
                  _vm._v(_vm._s(keys)),
                ]),
                _vm._l(item, function (n, index) {
                  return _c("p", { key: index, staticClass: "serviceSelect" }, [
                    _vm._v(_vm._s(n)),
                  ])
                }),
              ],
              2
            )
          }),
          0
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "p_1" }, [_vm._v("时间1:2021-06-20 1晚")]),
      _c("p", { staticClass: "p_2" }, [
        _vm._v("想大约下午5点开始用会场晚上10点结束 "),
        _c("span", [_vm._v("(有内容显示 没内容该行不显示)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p_2" }, [
      _vm._v("预算可以提高，人数不会超过35 "),
      _c("span", [_vm._v("(有内容显示 没内容该行不显示)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }